export const toSnakeCase = (str: string): string => {
  // replace all capital letters with an underscore and their lower case equivalent
  // WARN: this approach may have unintended consequences on props like productID => product_i_d
  // following proper naming conventions can help avoid this
  return str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
};

export const toCamelCase = (str: string): string => {
  // replace all underscores and their following letter with a capital version
  return str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
};
